import PageIntro from "@/components/PageIntro";
import Faq from "@/components/sections/Faq";

export default function FaqPage() {
  return (
    <div data-testid="faq-page">
      <PageIntro
        eyebrow="FAQ"
        title="Häufige Fragen"
        lead="Die wichtigsten Antworten rund um FestivalPlan – kompakt an einem Ort. Nicht fündig geworden? Unser Support hilft dir gerne weiter."
      />
      <Faq withHeading={false} />
    </div>
  );
}
